module.exports = __webpack_public_path__ + "static/img/101603.66374892.png";